export interface User {
  id: string
  email: string
  username: string
  role: UserRole
  companyId?: string | null // null means no company, string means company-specific user
  createdAt: string
  firstName?: string
  lastName?: string
  title?: string
  bio?: string
  contact?: string
  avatar?: string
  gameCharacter?: string
  customAvatarUrl?: string
  profileCompleted?: boolean
}

export enum UserRole {
  USER = 'user',
  MODERATOR = 'moderator',
  ADMIN = 'admin'
}

export interface UserProfile {
  firstName?: string
  lastName?: string
  /** Optional, max 30 characters (SC-438). When set it is shown instead of first + last name. */
  displayName?: string
  title?: string
  bio?: string
  contact?: string
  avatar?: string
  gameCharacter?: string
  customAvatarUrl?: string
  profileCompleted?: boolean
  role?: string
  gender?: string
  dateOfBirth?: string | Date
  /** Persisted hint: custom_upload | google | boring_variant (optional on older rows). */
  avatarSource?: string
  /** ISO string or Date from Parse; used for cache-busting avatar URLs. */
  avatarUpdatedAt?: string | Date
  /**
   * The user chose no photo (removed it or picked a generated style). Google sign-in only fills an
   * empty photo with the Google picture when this is not true.
   */
  photoOptOut?: boolean
}

export interface AuthUser {
  id: string
  email: string
  username: string
  createdAt: Date
  sessionToken?: string
  emailVerified?: boolean
  // Optional profile fields (merged from profile when available)
  role?: string
  firstName?: string
  lastName?: string
  title?: string
  contact?: string
  bio?: string
  avatar?: string
  gameCharacter?: string
  customAvatarUrl?: string
  profileCompleted?: boolean
}

export interface AuthResponse {
  user: AuthUser
  profile?: UserProfile
  sessionToken?: string
  /** True when Google OAuth just created a new account (not a returning login). */
  isNewUser?: boolean
}

export interface AuthError {
  code: number
  message: string
  field?: string
} 